import React, { useEffect, useState } from "react";
import {
  Container,
  Grid,
  Paper,
  Typography,
  Divider,
  Button,
  Link,
  useTheme,
  Box,
} from "@mui/material";
import Color from "../../theme/color";
import { DataTable } from "./data-table";
import { useLocation, useNavigate } from "react-router-dom";
import FullScreenLoader from "../../components/full-screen-loader";
import { GET, POST } from "../../config/https";
import APIS from "../../config/api";
import moment from "moment";
import { usePersistentState } from "../../contexts/global-context";
import { STRING } from "../../resources/string";
import TopTabBar from "../../components/app-bar";
import useMediaQuery from "@mui/material/useMediaQuery";
import NumberFormat from "../../components/number-format";
import { stringify } from "querystring";
import { defaultState } from "../../utils/constant";

interface PaymentIntents {
  status?: string;
  client_secret?: string;
}

const CheckoutSuccessPage: React.FC = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [loading, setLoading] = useState(false);
  const [checkOutLoading, setCheckOutLoading] = useState(false);
  const [state, dispatch]: any = usePersistentState();
  const [retrievePaymentResponse, setRetrievePaymentResponse] = useState<PaymentIntents>({});
  const [orderDetail, setOrderDetail] = useState<any>({});
  const [checkoutById, setCheckOutById] = useState<any>({});
  const [paymentType, setPaymentType] = useState({ stripe: false, host: false, free: false });
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [currentDateTime, setCurrentDateTime] = useState("");
  const redirectStatus = searchParams.get("redirect_status");
  const paymentIntent = searchParams.get("payment_intent");
  const navigate = useNavigate();
  useEffect(() => {
    if (state?.customerInfo?.customerDetail?.id) {
      if (checkOutLoading == false) {
        checkOutById();
        setCheckOutLoading(true);
      }
    }
    // Card and Zell
    else if (paymentIntent) {
      let paymentTypes = { ...paymentType };
      paymentRetrieve();
      paymentTypes.stripe = true;
      setPaymentType(paymentTypes);
    } else {
      navigate("/home");
    }
  }, [redirectStatus]);

  useEffect(() => {
    const formattedDateTime = moment().format("YYYY-MM-DD HH:mm:ss");
    setCurrentDateTime(formattedDateTime);
  }, []);

  const paymentRetrieve = async () => {
    if (!paymentIntent) return;
    let param = { paymentIntentId: paymentIntent };
    setLoading(true);
    await POST(APIS.RETRIEVE_PAYMENT, param)
      .then(async (res: any) => {
        // debugger;
        setRetrievePaymentResponse(res.retrivePaymentResponse);
        setOrderDetail(res.orderDetail);
        dispatch({ isStripeSuccess: true });
        let isStripeSuccess = true;
        localStorage.setItem("isStripeSuccess", JSON.stringify(isStripeSuccess));
        localStorage.setItem("isPaymentSuccess", "true");
      })
      .catch(() => {
        console.log("error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const checkOutById = async () => {
    setLoading(true);
    await GET(`${APIS.CHECKOUT}/${state?.customerInfo?.orderDetail?.id}`)
      .then(async (res: any) => {
        if (res?.isSuccess) {
          setCheckOutById(res?.result);
          if (res?.result?.orderDetail?.paymentType?.id === STRING.PAYMENT_TYPE_ID.ISSUE_FREE_TICKET) {
            let paymentTypes = { ...paymentType };
            paymentTypes.free = true;
            setPaymentType(paymentTypes);
            setOrderDetail(state?.customerInfo?.orderDetail);
            UpdateStatus(state?.customerInfo?.orderDetail?.id);
          } else {
            let paymentTypes = { ...paymentType };
            paymentTypes.host = true;
            setPaymentType(paymentTypes);
          }
          localStorage.setItem("isPaymentSuccess", "true");
        }
      })
      .catch((error) => {
        console.log("error", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDownloadTicket = async () => {
    await GET(`${APIS.DOWNLOAD_TICKET_PDF}?OrderId=${orderDetail?.id}`)
      .then(async (res: any) => {
        fetch(res)
          .then((response) => response.blob())
          .then((blob) => {
            const url = URL.createObjectURL(blob);
            const anchor = document.createElement("a");
            anchor.href = url;
            anchor.download = "EventPrix - Ticket.pdf";
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
            URL.revokeObjectURL(url);
          })
          .catch((error) => {
            console.error("Error downloading file:", error);
          });
      })
      .catch((error) => {
        console.log("error", error);
      })
      .finally(() => {});
  };

  function convertFromCents(centValue: any) {
    var normalAmount = centValue / 100;
    return normalAmount;
  }

  const getTotalAmount = () => {
    if (orderDetail?.client_secret?.amount) {
      return convertFromCents(orderDetail?.client_secret?.amount);
    }
    if (checkoutById?.orderDetail?.total) {
      return checkoutById?.orderDetail?.total;
    }
  };

  const UpdateStatus = async (orderId: any) => {
    await POST(APIS.PAYMENT_STATUS_UPDATE + "?Id=" + orderId + "&PaymentStatusId=2")
      .then((res: any) => {
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  return (
    <>
      <TopTabBar
        backgroundColors={"#2f3138"}
        textColor={"#fff"}
        iconColor={"#2f3138"}
        boxShadow={"none"}
      />
      <section id="home">
        <div
          style={{
            backgroundImage: `url(${"https://eventprix.com/wp-content/uploads/2023/04/Add-to-Cart-Banner.jpg"})`,
            backgroundSize: isSmallScreen ? "cover" : "cover",
            height: isSmallScreen ? "50vh" : "40vh",
            width: "100%",
            position: "relative",
            backgroundAttachment: "fixed",
            transition: "background-image 0.5s ease-in-out",
          }}
        >
          <div
            style={{
              backgroundColor: "#000",
              opacity: 0.6,
              transition: "background 0.3s, border-radius 0.3s, opacity 0.3s",
              position: "relative",
              height: isSmallScreen ? "50vh" : "40vh",
            }}
          />
        </div>
      </section>
      <Grid container spacing={0} alignItems="center" justifyContent="center" position={"absolute"} top={0} sx={{ display: "flex", flexDirection: "column" }}>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" height={isSmallScreen ? "40vh" : "calc(53vh - 55px)"}
            color="white" marginTop={isSmallScreen ? "130px" : "0"}>
            <Typography style={{ color: "#fff", fontFamily: "Poppins", fontWeight: 600, fontSize: isSmallScreen ? "30px" : "60px" }} align="center" variant="h1"> Checkout</Typography>
          </Box>
        </div>
      </Grid>
      <Container maxWidth="lg" style={{ marginTop: "10px" }}>
        <Paper style={{ padding: "20px", textAlign: "center" }}>
          <Grid container spacing={2} style={{ margin: "20px", display: "flex", alignItems: "center", }}>
            <Grid item xs={paymentType.stripe ? 12 : 0} sm={7} md={8} style={{ paddingLeft: 0, paddingTop: 0, alignItems: "center", textAlign: "start", marginBottom: isSmallScreen ? "10px" : "" }}>
              {
                checkoutById?.orderDetail?.paymentTypeId === STRING.PAYMENT_TYPE_ID.PAY_TO_HOST && (
                  <Typography variant="subtitle1" style={{ color: Color.color13, fontSize: 14, textAlign: "left", overflowWrap: "break-word", width: isSmallScreen ? "90%" : "100%" }}>
                    Thank you! Your order is on hold. Your host will issue the
                    ticket once they receive the amount.
                            <br />
                            <span style={{ color: "red", fontWeight: "bold" }}>
                                Note : All taxes are payable by the event host.
                            </span>
                  </Typography>
                )}

              {
                checkoutById?.orderDetail?.paymentTypeId === STRING.PAYMENT_TYPE_ID.ZELLE ? (
                  <Typography variant="subtitle1" style={{ color: Color.color13, fontSize: 14, textAlign: "left", overflowWrap: "break-word", width: isSmallScreen ? "90%" : "100%" }}>
                    Thank you! Your order is on hold. EventPrix Admin will issue
                    the ticket once they receive the amount through Zelle.
                  </Typography>
                ) : (
                  <>
                    {
                      checkoutById?.orderDetail?.paymentTypeId === STRING.PAYMENT_TYPE_ID.CARD ? (
                        <Typography style={{ overflowWrap: "break-word", color: Color.color13, fontSize: 14, textAlign: "left" }}>
                          Your order is on hold, Please contact Host/Admin to conform.</Typography>
                      ) : (
                        <>
                          {
                            loading ? (<FullScreenLoader open={true} />) : retrievePaymentResponse.status === "succeeded" ? (
                              <Typography variant="subtitle1" style={{ color: Color.color13, fontSize: 14, textAlign: "left", overflowWrap: "break-word", width: "90%" }}>
                                Thank you! your order has been confirmed and the
                                ticket has been sent to your email address.
                              </Typography>
                            ) : retrievePaymentResponse.status === "failed" ? (
                              <Typography variant="h4" style={{ overflowWrap: "break-word" }}>Sorry! Your Request Is Failed</Typography>
                            ) : (
                              <Typography variant="h4"></Typography>
                            )}
                        </>
                      )}
                  </>
                )}
            </Grid>
            {
              paymentType.stripe ? (
                <Grid item xs={paymentType.stripe ? 12 : 0} sm={5} md={4} style={{ paddingLeft: 0, paddingTop: 0, alignItems: "center", textAlign: "start" }}>
                  {
                    paymentType.stripe && (
                      <Button onClick={handleDownloadTicket} style={{ backgroundColor: Color.primary }} variant="contained">
                        Download Ticket
                      </Button>
                    )
                  }
                </Grid>
              ) : ("")
            }
          </Grid>
          <Grid container alignItems="center" spacing={2} style={{ margin: "10px" }}>

            <Grid item style={{ justifyContent: "center", paddingLeft: 0, paddingTop: 0, alignItems: "center", margin: "15px" }}>
              <Typography variant="subtitle1" style={{ color: Color.color13, fontSize: 14, textAlign: "left" }}>
                ORDER NUMBER:
              </Typography>
              <Typography variant="subtitle1" style={{ color: "#000" }}>
                {orderDetail?.orderNumber || checkoutById?.orderDetail?.orderNumber}
              </Typography>
            </Grid>

            <Divider orientation="vertical" flexItem />
            <Grid item style={{ justifyContent: "center", paddingLeft: 0, paddingTop: 0, alignItems: "center", margin: "15px" }}>
              <Typography variant="subtitle1" style={{ color: Color.color13, fontSize: 14, textAlign: "left" }}>
                DATE:{" "}
              </Typography>
              <Typography variant="subtitle1" style={{ color: "#000", textAlign: "left" }}>
                {moment(currentDateTime).format("ddd MMM D, YYYY, h:mm A")}
              </Typography>
            </Grid>
            <Divider orientation="vertical" flexItem />
            <Grid item style={{ justifyContent: "center", paddingLeft: 0, paddingTop: 0, alignItems: "center", margin: "15px" }}>
              <Typography variant="subtitle1" style={{ color: Color.color13, fontSize: 14, textAlign: "left" }}>
                TOTAL:
              </Typography>
              <Typography variant="subtitle1" style={{ color: "#000", textAlign: "left" }}>
                $ <NumberFormat total={orderDetail?.total || checkoutById?.orderDetail?.total} />
              </Typography>
            </Grid>
            <Divider orientation="vertical" flexItem />
            <Grid item style={{ justifyContent: "center", paddingLeft: 0, paddingTop: 0, alignItems: "center", margin: "15px" }}>
              <Typography variant="subtitle1" style={{ color: Color.color13, fontSize: 14, textAlign: "left" }}>
                PAYMENT METHOD:
              </Typography>
              <Typography variant="subtitle1" style={{ color: "#000", textAlign: "left" }}>
                {
                  checkoutById?.orderDetail?.paymentTypeId === STRING.PAYMENT_TYPE_ID.ZELLE ?
                    (<>{"Zelle (least service fee: recommended)"}</>) :
                    (<>
                      {
                        checkoutById?.orderDetail?.paymentTypeId === STRING.PAYMENT_TYPE_ID.PAY_TO_HOST ?
                          (<>{"Pay to event host"}</>) :
                          (
                            <>
                              {
                                checkoutById?.orderDetail?.paymentTypeId === STRING.PAYMENT_TYPE_ID.ISSUE_FREE_TICKET ?
                                  (<>{"Free Ticket"}</>) :
                                  (<>{"Card"}</>)
                              }
                            </>
                          )
                      }
                    </>
                    )
                }
              </Typography>
            </Grid>
            {
              paymentType.free ? (
                <Grid item xs={(paymentType.free) ? 12 : 0} sm={5} md={4} style={{ justifyContent: "center", paddingLeft: 0, paddingTop: 0, alignItems: "center", margin: "15px" }}>
                  {
                    paymentType.free && (
                      <Button onClick={handleDownloadTicket} style={{ backgroundColor: Color.primary }} variant="contained">
                        Download Ticket
                      </Button>
                    )
                  }
                </Grid>
              ) : ("")
            }
          </Grid>

          {checkoutById?.orderDetail?.paymentTypeId ===
            STRING.PAYMENT_TYPE_ID.ZELLE ? (
            <Grid item spacing={2} style={{ margin: "20px", justifyContent: "center", display: "flex", alignItems: "center" }}>
              <Grid item xs={12} style={{ justifyContent: "center", paddingLeft: 0, paddingTop: 0, alignItems: "center", textAlign: "start" }}>
                <Typography variant="h3" style={{ color: Color.color23, marginBottom: 15 }}>Zelle Notice</Typography>
                <Typography style={{ marginBottom: 10 }}>
                  <b>Step 1: </b>Initiate a Zelle transfer of{" "}
                  <b>
                    {" "}
                    $<NumberFormat total={getTotalAmount()} />
                  </b>{" "}
                  to{" "}
                  <Link href="mailto:pay@eventprix.com" color={Color.primary}>pay@eventprix.com</Link>.
                </Typography>
                <Typography style={{ marginBottom: 10 }}>
                  <b>Step 2: </b>Under “Add message” on Zelle screen, provide
                  the <b>Order id</b> that is shown above.
                </Typography>
                <Typography>
                  We will email your tickets to in less than 24 hours. If you
                  have questions, reach out to your event organizer or send us
                  an email at{" "}
                  <Link href="mailto:contact@eventprix.com" color={Color.primary}>
                    {" "}
                    contact@eventprix.com
                  </Link>.
                </Typography>
              </Grid>
            </Grid>
          ) : (
            <>
              {
                checkoutById?.orderDetail?.paymentTypeId === STRING.PAYMENT_TYPE_ID.PAY_TO_HOST ? (
                  <Grid item xs={12} style={{ justifyContent: "center", paddingLeft: 0, paddingTop: 0, alignItems: "center", textAlign: "start" }}>
                    {/* <Typography
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    Please pay the total amount shown above to your host.
                    Remember to share your ‘Order Id’ that is shown above with
                    your host. You will receive your tickets by email at the
                    address you entered within 24 hours.. Please note that
                    EventPrix cannot be held liable for any issues related to
                    this transaction.
                  </Typography> */}
                    <Box sx={{ backgroundColor: "#f9fafb", borderRadius: 2, p: 2, mb: 2, border: "1px solid #e0e0e0" }}>
                      <Typography style={{ marginBottom: 10 }}>
                        <p style={{ whiteSpace: "pre-line" }}>
                          {defaultState?.paymentOption?.hosttext.split(/(\S+@\S+\.\S+)/g).map((part, index) => {
                            if (/^\S+@\S+\.\S+$/.test(part)) {
                              return (
                                <a key={index} href={`mailto:${part}`} style={{ color: "#1976d2", fontWeight: "bold", textDecoration: "underline" }}>
                                  {part}
                                </a>
                              );
                            }
                            return part;
                          })}
                        </p>
                      </Typography>
                    </Box>
                  </Grid>
                ) : null}
            </>
          )}
        </Paper>
        <Paper style={{ padding: "20px", textAlign: "center" }}>
          <Grid container spacing={2} style={{ margin: "20px", justifyContent: "center", display: "flex", alignItems: "center" }}>
            <Grid item xs={12} style={{ justifyContent: "center", paddingLeft: 0, paddingTop: 0, alignItems: "center", textAlign: "start" }}>
              <Typography variant="h3" style={{ color: Color.color23 }}>Order details</Typography>
            </Grid>
          </Grid>
          <Grid container alignItems="center">
            <DataTable Data={orderDetail} retrievePaymentResponse={retrievePaymentResponse} checkOutByID={checkoutById} />
          </Grid>
        </Paper>
      </Container>
    </>
  );
};

export default CheckoutSuccessPage;
